"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserServiceLive = void 0;
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const HttpProvider_1 = require("../utils/HttpProvider");
const constants_1 = require("../utils/constants");
class UserServiceLive {
    async isNominee() {
        const response = await HttpProvider_1.httpProvider.get("/user/is-nominee");
        const payload = response.data?.payload;
        // HttpService treats 4xx as success, so a 403 body has no payload.
        if (payload == null || typeof payload.isNominee !== "boolean") {
            return { isNominee: false, nomineeForCompanyIds: [] };
        }
        return {
            isNominee: payload.isNominee,
            nomineeForCompanyIds: payload.nomineeForCompanyIds ?? [],
        };
    }
    async updateKycDoneStatus(body) {
        const response = await HttpProvider_1.httpProvider.patch("/user/kycstatus", body ?? {});
        return response.data.status;
    }
    async getUser() {
        const response = await HttpProvider_1.httpProvider.get(constants_1.GET_USER);
        return response.data.payload;
    }
    async getUserById(userId) {
        const response = await HttpProvider_1.httpProvider.get(`/user/${userId}/get-user-by-id`);
        return response.data.payload;
    }
    async updateUserPrimaryPhone(phoneDetails) {
        const response = await HttpProvider_1.httpProvider.patch(constants_1.UPDATE_PRIMARY_PHONE, {
            ...phoneDetails,
        });
        return response.data.payload.status;
    }
    async isEmailExists(email) {
        const response = await HttpProvider_1.httpProvider.post(constants_1.EMAIL_EXISTS, {
            email,
        });
        return response.data.payload.emailExists;
    }
    async isAcnExists(acn, isForeignEntity = false) {
        const response = await HttpProvider_1.httpProvider.post(constants_1.ACN_EXISTS, {
            acn,
            ...(isForeignEntity && { isForeignEntity }),
        });
        return response.data.payload.acnExists;
    }
    async updateEmail(email) {
        const response = await HttpProvider_1.httpProvider.patch(constants_1.UPDATE_PRIMARY_EMAIL, { email });
        return response.data.payload.newEmail;
    }
    async updateDobAddress(dobAddressData) {
        const response = await HttpProvider_1.httpProvider.patch("/user/pre-kyc", {
            birthDetails: {
                dob: dobAddressData.dob,
                birthPlace: "",
                birthCountry: "",
            },
            kycDetails: {
                isKYCDone: false,
                address: {
                    description: dobAddressData.description,
                    flatNumber: dobAddressData.flatNumber || "",
                    streetNumber: dobAddressData.streetNumber,
                    propertyName: dobAddressData.propertyName,
                    streetName: dobAddressData.streetName,
                    suburb: dobAddressData.suburb,
                    townCity: dobAddressData.townCity,
                    city: dobAddressData.city,
                    postcode: dobAddressData.postcode,
                    state: dobAddressData.state,
                    country: dobAddressData.country,
                },
                verificationId: "",
                verificationToken: "",
            },
        });
        return response.data.status;
    }
    async removePreKycDetails() {
        const response = await HttpProvider_1.httpProvider.patch("/user/remove-pre-kyc");
        return response.data.payload;
    }
    // eslint-disable-next-line consistent-return
    async updateKycDetails(updateKycDetailsData) {
        if (updateKycDetailsData) {
            const response = await HttpProvider_1.httpProvider.patch("/user/pre-kyc", {
                birthDetails: {
                    dob: updateKycDetailsData.dob,
                    birthPlace: "",
                    birthCountry: "",
                },
                kycDetails: {
                    isKYCDone: updateKycDetailsData.isKYCDone,
                    address: updateKycDetailsData.address,
                    verificationId: updateKycDetailsData.verificationId,
                    verificationToken: updateKycDetailsData.verificationToken,
                },
            });
            return response.data.status;
        }
        return false;
    }
    async updateAddressDetails(updateAddressDetailsData) {
        if (updateAddressDetailsData) {
            const response = await HttpProvider_1.httpProvider.patch("/user/address", {
                careOf: updateAddressDetailsData.careOf,
                line2: updateAddressDetailsData.line2,
                street: updateAddressDetailsData.street,
                locality: updateAddressDetailsData.locality,
                state: updateAddressDetailsData.state,
                postcode: updateAddressDetailsData.postcode,
                country: updateAddressDetailsData.country,
            });
            return response.data.status;
        }
        return false;
    }
    async requestPasswordReset(requestPasswordResetRequestBody) {
        // eslint-disable-next-line no-return-await
        const response = await HttpProvider_1.httpProvider.post("/user/forgot-password", requestPasswordResetRequestBody);
        return response.data;
    }
    async setNewPassword(authToken, setNewPasswordRequestBody) {
        const headers = { authorization: `Bearer ${authToken}` };
        // eslint-disable-next-line no-return-await
        const response = await HttpProvider_1.httpProvider.post("/user/set-password", setNewPasswordRequestBody, headers);
        return response.data;
    }
    async verifyThenUpdateMobileNumber(verifyThenUpdateMobileNumberRequestBody) {
        // eslint-disable-next-line no-return-await
        const response = await HttpProvider_1.httpProvider.post("/user/phones/verify-and-update", verifyThenUpdateMobileNumberRequestBody);
        return response.data;
    }
    async linkNomineeExistingAccount(linkNomineeExistingAccountRequestBody) {
        const response = await HttpProvider_1.httpProvider.post("/nominee/link-existing-account", linkNomineeExistingAccountRequestBody);
        return response.data;
    }
    async updateLastLogin(username) {
        if (username) {
            const response = await HttpProvider_1.httpProvider.patch("/user/last-login", {
                username,
            });
            return response.data.status;
        }
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async getUserCompanies(page, pageSize, sortField) {
        const response = await HttpProvider_1.httpProvider.get(`/user/profile/companies?page=${page}&pageSize=${pageSize}&sortField=${sortField}`);
        return response.data;
    }
    async grantShareholderRole(companyId, role) {
        const response = await HttpProvider_1.httpProvider.post("/user/grant-access", {
            companyId,
            role,
        });
        return response.data.payload;
    }
    async getInvestorProfiles(companyId, filterByCompany = false, status = [mystake_common_sdk_1.ShareholderStatus.ACCEPTED], keyword, page, rowsPerPage, sortBy, sortOrder) {
        const response = await HttpProvider_1.httpProvider.get(`/user/investors?companyId=${companyId}&filterByCompany=${filterByCompany}&status=${status}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&sortOrder=${sortOrder}&keyword=${keyword}`);
        return response.data;
    }
}
exports.UserServiceLive = UserServiceLive;
//# sourceMappingURL=UserServiceLive.js.map